/**
 * پیام‌های موقتِ بالای صفحه (antd `message`) — درشت‌تر و پررنگ‌تر (v2.119.0).
 *
 * کاربر (۱۴۰۵/۰۷/۰۴): «ارورهایی که به‌صورتِ موقت بالای صفحه می‌آید را بولدتر و بزرگ‌تر کن که وقتی مثلاً تولید
 * خطایی می‌دهد راحت‌تر ببینند». ظاهر در `theme/gharchak-theme.css` (کلاسِ ant-message)؛ اینجا فقط زمان:
 * خطا/هشدار بیشتر روی صفحه می‌ماند تا خوانده شود (پیش‌فرضِ antd ۳ ثانیه برای همه بود).
 */
import { message } from "antd";

const LONGER = { error: 7, warning: 5 };

export function installToastStyle() {
  message.config({ top: 20, maxCount: 4 });
  Object.entries(LONGER).forEach(([kind, secs]) => {
    const orig = message[kind];
    if (!orig || orig.__gxLonger) return;
    const wrapped = (content, duration, onClose) => {
      // شکلِ شیئی: message.error({ content, duration })
      if (content && typeof content === "object" && !Array.isArray(content) && "content" in content) {
        return orig({ duration: secs, ...content });
      }
      return orig(content, duration ?? secs, onClose);
    };
    wrapped.__gxLonger = true;
    message[kind] = wrapped;
  });
}
